module.exports = "<div ng-if=\"$ctrl.route.type === 'climbing'\"> <ng-include src=\"'app/route/view/segmentdetails/partial_climbing.html'\"></ng-include> </div> <div ng-if=\"$ctrl.route.type !== 'climbing'\"> <ng-include src=\"'app/route/view/segmentdetails/partial_others.html'\"></ng-include> </div> <app-photo-view photo-list=$ctrl.segment.photos main-lang=$ctrl.route.main_lang ng-if=\"$ctrl.segment.type === 'course'\"> </app-photo-view> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/view/segmentdetails/partial.html
// module id = 511
// module chunks = 0